import React, { ReactNode } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BackButton } from './Buttons';

const useStyles = createUseStyles<string, {}, any>((theme: Theme) => ({
  header: {
    width: '100%',
    borderRadius: theme.borderRadius.large,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.marginBase * 5,
  },
  leftContainer: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    gap: theme.marginBase,
  },
  rightContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
  },
  icon: {
    color: theme.colors.inkTertiary,
    fontSize: theme.iconSize.large,
  },
  name: {
    ...theme.fonts.h4,
  },
}));

interface Props {
  icon?: ReactNode;
  title?: string;
  className?: string;
  to?: string;
}

export const InformationHeader = ({ icon, title, className, to }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classnames(classes.header, className)}>
      <div className={classes.leftContainer}>
        {icon && <i className={classnames(icon, classes.icon)} />}
        {!!title && <h1 className={classes.name}>{title}</h1>}
      </div>
      <div className={classes.rightContainer}>
        <BackButton icon="ri-close-line" color="ink" to={to} />
      </div>
    </div>
  );
};
